import React, { useState } from 'react';
import { teachers, Teacher } from '../data/teachers';
import TeacherModal from './TeacherModal';
import { convertLocalToExternal } from '../services/imageService';
import '../styles/testimonials.css';

const Testimonials: React.FC = () => {
    const [selectedTeacher, setSelectedTeacher] = useState<Teacher | null>(null);

    const openModal = (teacher: Teacher) => {
        setSelectedTeacher(teacher);
    };

    const closeModal = () => {
        setSelectedTeacher(null);
    };

    // Função para obter URL da imagem (converte path local para Cloudinary)
    const getPhotoUrl = (photoUrl: string): string => {
        return convertLocalToExternal(photoUrl);
    };

    return (
        <>
            <div className="testimonials-container">
                <div className="testimonials-grid">
                    {teachers.map((teacher) => (
                        <div 
                            key={teacher.id} 
                            className="testimonial-card fade-in"
                            onClick={() => openModal(teacher)}
                        >
                            <div className="teacher-photo-container">
                                <img 
                                    src={getPhotoUrl(teacher.photoUrl)} 
                                    alt={teacher.name}
                                    className="teacher-photo"
                                />
                            </div>
                            <div className="testimonial-content">
                                <h3 className="teacher-name">{teacher.name}</h3>
                                
                                {/* Matérias com hover tooltip */}
                                {teacher.subjects && teacher.subjects.length > 0 && (
                                    <div className="teacher-subjects">
                                        {teacher.subjects.map((subject, index) => (
                                            <span 
                                                key={index} 
                                                className="subject-badge" 
                                                title={subject.fullName}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {subject.abbreviation}
                                            </span>
                                        ))}
                                    </div>
                                )}

                                {/* Preview do depoimento */}
                                <div className="testimonial-preview">
                                    <p className="testimonial-text-preview">
                                        {teacher.testimonial.substring(0, 120)}...
                                    </p>
                                </div>

                                {/* Botão para ver mais */}
                                <button 
                                    className="view-more-button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openModal(teacher);
                                    }}
                                >
                                    Ver depoimento completo
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <TeacherModal teacher={selectedTeacher} onClose={closeModal} />
        </>
    );
};

export default Testimonials;